import { type FC } from 'react';
import { IconButton } from '@chakra-ui/react';
import { ReactComponent as CalendarIcon } from '../../assets/svg/CalendarIcon.svg';
import { translate } from '../../constants/translation';

interface Props {
  onOpen: () => void;
}

const PickTimeButton: FC<Props> = ({ onOpen }): JSX.Element => {
  return (
    <IconButton variant="secondary" icon={<CalendarIcon />} aria-label={translate('PICK_TIME')} onClick={onOpen} />
  );
};

export default PickTimeButton;
